import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IMenuProvider, Menu } from '@maersk-global/angular-shared-library';
import { combineLatestWith, filter, map, Observable, shareReplay } from 'rxjs';
import { User } from '../../api/models/user';
import { DcrpAuthorizationService } from '../authorization/dcrp-authorization.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SideNavMenuService implements IMenuProvider {
  constructor(
    private _router: Router,
    private _dcrpAuthorizationService: DcrpAuthorizationService
  ) {}

  event$ = this._router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    shareReplay(1)
  );

  getMenuAsync(): Observable<Menu[]> {
    return this.event$.pipe(
      combineLatestWith(this._dcrpAuthorizationService.dcrpUser$),
      map(([event, user]: [any, User | undefined]) => {
        return [
          {
            displayName: 'Customer',
            icon: 'user',
            showLabel: true,
            isSelected: event.urlAfterRedirects.includes('customer-recovery'),
            onClick: () => {
              this._router.navigate(['customer-recovery']);
            },
          },
          {
            displayName: 'Vendor',
            icon: 'wrench',
            showLabel: true,
            isSelected: event.urlAfterRedirects.includes('vendor-recovery'),
            onClick: () => {
              this._router.navigate(['vendor-recovery']);
            },
          },
          {
            displayName: 'CP Insights',
            icon: 'magnifying-glass',
            showLabel: true,
            isSelected: event.urlAfterRedirects.includes('cp-insights'),
            onClick: () => {
              this._router.navigate(['cp-insights']);
            },
          },
          {
            displayName: 'FEA Recoveries',
            icon: 'flag',
            showLabel: true,
            hidden: !user?.userRoles?.find(
              (role) =>
                role.role.roleName == 'Admin' ||
                role.role.roleName == 'Specialist'
            )?.role,
            disabled: !environment.enableFea,
            isSelected: event.urlAfterRedirects.includes('fea-recoveries'),
            onClick: () => {
              this._router.navigate(['fea-recoveries']);
            },
          },
          {
            displayName: 'Dert Images',
            icon: 'image',
            showLabel: true,
            hidden: !environment.enableDertImage,
            isSelected: event.urlAfterRedirects.includes('dert-images'),
            onClick: () => {
              this._router.navigate(['dert-images']);
            },
          },
          {
            displayName: 'Admin',
            icon: 'shield',
            showLabel: true,
            hidden: !user?.userRoles?.find(
              (role) => role.role.roleName === 'Support-Admin'
            )?.role,
            isSelected: event.urlAfterRedirects.includes('admin'),
            onClick: () => {
              this._router.navigate(['admin']);
            },
          },
        ];
      })
    );
  }

  getSettingsMenuAsync(): Observable<Menu[]> {
    return this.event$.pipe(
      combineLatestWith(this._dcrpAuthorizationService.dcrpUser$),
      map(([event, user]: [any, User | undefined]) => {
        return [
          {
            displayName: 'Settings',
            icon: 'cog',
            showLabel: true,
            subMenus: [
              {
                displayName: 'Tariffs',
                icon: 'quote',
                showLabel: true,
                isSelected: event.urlAfterRedirects.includes('tariffs'),
                onClick: () => {
                  this._router.navigate(['tariffs']);
                },
              },
              {
                displayName: 'Auto Invoice Configuration',
                icon: 'sliders-vertical',
                showLabel: true,
                hidden: !user?.userRoles?.find(
                  (role) =>
                    role.role.roleName == 'Admin' ||
                    role.role.roleName == 'Manager'
                )?.role,
                isSelected: event.urlAfterRedirects.includes(
                  'auto-invoice-configuration'
                ),
                onClick: () => {
                  this._router.navigate(['auto-invoice-configuration']);
                },
              },
              {
                displayName: 'CAM Exception',
                icon: 'clipboard-list-text',
                showLabel: true,
                isSelected: event.urlAfterRedirects.includes('cam'),
                onClick: () => {
                  this._router.navigate(['cam']);
                },
              },
            ],
          },
        ];
      })
    );
  }
}
